import { connect } from 'react-redux'
import CommandsPage from './commands-page'
import { config } from '../../../redux/selectors'
import { withRouter } from 'react-router-dom'

const mapState = (state, ownProps) => {
  return {
    config: config(state),
    ...ownProps,
  }
}

const mapDispatch = dispatch => {
  return {}
}

export default withRouter(connect(mapState, mapDispatch)(CommandsPage))



// WEBPACK FOOTER //
// ./src/components/views/commands-page/commands-page.connect.jsx